/**
 * Tables → Version History: route for the row action (audit preview).
 * Save / edit → revision preview; copy / move / delete and the rest → current-node preview.
 */
export function getVersionHistoryAuditPreviewPath(auditTrailId, actionText) {
  if (!auditTrailId) return null;
  const a = String(actionText || "");
  if (/\bsave\b/i.test(a) || /\bedit\b/i.test(a) || /\bedited\b/i.test(a)) {
    return `/audit-trail/preview/${auditTrailId}`;
  }
  return `/audit-trail/preview-current-node/${auditTrailId}`;
}
